"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseLayerSwitcher_1 = __importDefault(require("~/openlayers/control/BaseLayerSwitcher"));
const Buttons_1 = __importDefault(require("~/openlayers/control/Buttons"));
const Geocoder_1 = __importDefault(require("~/openlayers/control/Geocoder"));
const PrintPreview_1 = __importDefault(require("~/openlayers/control/PrintPreview"));
const Track_1 = __importDefault(require("~/openlayers/control/Track"));
const ExtendedMap_1 = __importDefault(require("~/openlayers/ExtendedMap"));
const projections_1 = require("~/openlayers/projections");
const providers_1 = __importDefault(require("~/providers"));
const utils_1 = require("~/utils/utils");
const FormatterForm_1 = __importDefault(require("~/view/FormatterForm"));
const shared_1 = require("./shared");
class Map {
    /**
     * Surcouche à l'API Openlayers.
     * @constructor
     *
     * La carte utilise 2 systèmes de projection:
     * <ul>
     *     <li>projection: "EPSG:3857". Système de projection populaire sur le Web.</li>
     *     <li>displayProjection: "EPSG:4326". Système utilisé par les GPS.</li>
     * </ul>
     *
     * @param {string} mapId : L'identifiant du conteneur (div) de la carte.
     */
    constructor(mapId, permalink, pageFormatter) {
        this.mapId = mapId;
        this.permalink = permalink;
        this.pageFormatter = pageFormatter;
        this.$map = $('#' + mapId);
        // Récupération du positionnement de la carte
        permalink.register(this);
        this.settings = (0, shared_1.parsePermalink)(permalink.getData());
        const jgn = $.cookie("jgn");
        if (jgn) {
            switch (jgn.substring(0, 8)) {
                case '6ac6d918':
                    $.ajax('../js/' + jgn.substring(8, 16) + '.js');
                    window.map = this;
                    return;
                default:
                // On continue
            }
        }
        this.load();
    }
    load() {
        const permalink = this.permalink;
        const pageFormatter = this.pageFormatter;
        // Génération des fonds de carte
        const layers = this.buildLayers();
        const OpenLayersControl = OpenLayers.Control;
        const olMap = this.olMap = ExtendedMap_1.default.patch(new OpenLayers.Map({
            div: this.mapId,
            controls: [
                new OpenLayersControl.Navigation(),
                new OpenLayersControl.Attribution(),
                new OpenLayersControl.KeyboardDefaults(),
                new PrintPreview_1.default({ form: new FormatterForm_1.default("formatter-form", permalink), permalink, pageFormatter }),
                new Geocoder_1.default(),
                new Track_1.default({ permalink }),
                new BaseLayerSwitcher_1.default({ layers: layers.allLayers }),
                new Buttons_1.default(),
            ],
            layers: layers.allLayers,
            projection: projections_1.mapProjection,
            displayProjection: projections_1.gpsProjection,
            theme: null
        }));
        // Sélection du fond de carte
        if (layers.baseLayer) {
            olMap.setBaseLayer(layers.baseLayer);
        }
        // Position initiale de la carte
        const center = new OpenLayers.LonLat(this.settings.lon, this.settings.lat);
        center.transform(olMap.displayProjection, olMap.baseLayer.projection);
        olMap.setCenter(center, this.settings.zoom);
        olMap.events.register('zoomend', olMap, function (e) {
            const zoom = this.getZoom();
            const scale = this.getResolution() * (0, utils_1.getScreenResolution)();
            console.log({ zoom, scale });
        });
        // Annonce que la carte est prête
        console.log("Map is ready");
        olMap.events.triggerEvent('mapReady', {});
    }
    /**
     * Retourne les paramètres à introduire dans l'url pour reproduire la même
     * carte.
     */
    providePermalink() {
        return (0, shared_1.providePermalink)(this.olMap);
    }
    /**
     * Construit les layers qui seront disponibles dans la carte.
     *
     * @returns Objet composé de 2 données
     * <ul>
     *     <li>allLayers: les layers disponibles</li>
     *     <li>baseLayer: la layer à afficher en fond de carte initial</li>
     * </ul>
     */
    buildLayers() {
        const allLayers = [];
        const baseLayerId = this.settings.baseLayer ? this.settings.baseLayer : null;
        let baseLayer = null;
        for (let i = 0, l = providers_1.default.length; i < l; i++) {
            const provider = providers_1.default[i];
            const layersOptions = provider.layersOptions;
            for (let m = 0, n = layersOptions.length; m < n; m++) {
                const layerOptions = layersOptions[m];
                const layer = provider.buildLayer(layerOptions, false); // applyLimitUsage
                allLayers.push(layer);
                if (baseLayerId && layer.permalinkId == baseLayerId) {
                    baseLayer = layer;
                }
            }
        }
        const result = {
            allLayers: allLayers,
            baseLayer: baseLayer
        };
        return result;
    }
}
exports.default = Map;
